// Charge la base commune
// Styles librairies

// Styles custom
import './scss/pages/credit-simulators'

// Scripts librairies
import { pageLoading } from 'js/custom_script'

require('./common.js')

// Components
function getSimulatorMonthly () {
  pageLoading()
  import('./js/components/simulator-monthly-form.js').then(() => {
    pageLoading(false)
  })
}

function getSimulatorCapacity () {
  pageLoading()
  import('./js/components/simulator-loan-capacity-form.js').then(() => {
    pageLoading(false)
  })
}

function getSimulatorBorrowing () {
  pageLoading()
  import('./js/components/simulator-borrowing-amount-form.js').then(() => {
    pageLoading(false)
  })
}

function getSimulatorDebt () {
  pageLoading()
  import('./js/components/simulator-debt-ratio-form.js').then(() => {
    pageLoading(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  if ($('#wdyw').length) {
    const target = $('#wdyw')
    $('html, body').animate({
      scrollTop: ($(target).offset().top - 124) - -1
    }, 500)
  }

  if ($('#monthly').length) { getSimulatorMonthly() }

  if ($('#capacity').length) { getSimulatorCapacity() }

  if ($('#borrowing').length) { getSimulatorBorrowing() }

  if ($('#debt').length) { getSimulatorDebt() }
})
